import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const MortgageList = () => {
    const [mortgages, setMortgages] = useState([]);
    const [loading, setLoading] = useState(true); // Manage loading state

    useEffect(() => {
        // Fetch the mortgage data from the API
        axios.get('/api/balance_sheet/financing/mortgages/')
            .then(response => {
                console.log(response.data); // Log the response data for debugging
                setMortgages(response.data); // Populate the component state
                setLoading(false); // Stop loading
            })
            .catch(error => {
                console.error('Error fetching mortgage data:', error);
                setLoading(false); // Stop loading even on error
            });
    }, []); // Empty dependency array ensures this runs only on mount

    // Loading message while fetching data
    if (loading) {
        return <div>Loading mortgages...</div>;
    }

    const handleRemove = async (id) => {
        try {
            await axios.delete(`/api/balance_sheet/financing/mortgages/${id}/`); // Call DELETE API
            // Update state to remove the deleted mortgage
            setMortgages((prevMortgages) => prevMortgages.filter(mortgage => mortgage.id !== id));
            alert("Loan removed successfully");
        } catch (error) {
            console.error("Error removing loan:", error);
            alert("There was an error removing the loan.");
        }
    };

    // Helper function to format currency
    const formatCurrency = (amount) => {
        return `$${Math.round(amount).toLocaleString()}`;
    };

    return (
        <div style={{ marginLeft: '40px' }}>
            <h1>Mortgage List</h1>
            <Link to="/balance_sheet/financing/create-loan/">
                <button type="button" className="btn btn-primary">Create New Mortgage</button>
            </Link>
            <table className="mortgage-table">
                <thead>
                    <tr>
                        <th>Loan ID</th>
                        <th>Lender</th>
                        <th>Loan Amount</th>
                        <th>Interest Rate</th>
                        <th>Term (Years)</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {mortgages.length > 0 ? (
                        mortgages.map(mortgage => (
                            <tr key={mortgage.id}>
                                <td>
                                    <Link to={`/balance_sheet/financing/mortgages/${mortgage.id}`}>{mortgage.id}</Link>
                                </td>
                                <td>{mortgage.lender}</td>
                                <td>{formatCurrency(mortgage.amount)}</td>
                                <td>{mortgage.initial_interest_rate}%</td>
                                <td>{mortgage.term_in_years}</td>
                                <td>
                                    <button type="button" className="btn btn-danger" onClick={() => handleRemove(mortgage.id)}>Remove</button>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="6" style={{ textAlign: 'center' }}>No mortgages found.</td>
                        </tr>
                    )}
                </tbody>
            </table>
            <style jsx>{`
                .mortgage-table {
                    margin: 20px;
                    width: 90%;
                    table-layout: auto;
                    border-collapse: collapse;
                }
                .mortgage-table th, .mortgage-table td {
                    border: 1px solid #ccc;
                    padding: 10px;
                    text-align: left;
                }
                .mortgage-table th {
                    background-color: #f0f0f0;
                }
                button {
                    background-color: #ff4d4d;
                    color: white;
                    border: none;
                    padding: 5px 10px;
                    cursor: pointer;
                }
                button:hover {
                    background-color: #ff0000;
                }
            `}</style>
        </div>
    );
};

export default MortgageList;


// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { Link } from 'react-router-dom'; // Import Link for navigation
//
// const MortgageList = () => {
//     const [mortgages, setMortgages] = useState([]);
//     const [loading, setLoading] = useState(true); // Manage loading state
//
//     useEffect(() => {
//         // Fetch the mortgage data from the API
//         axios.get('/debt/mortgages/')
//             .then(response => {
//                 console.log(response.data); // Log the response data for debugging
//                 setMortgages(response.data); // Populate the component state
//                 setLoading(false); // Stop loading
//             })
//             .catch(error => {
//                 console.error('Error fetching mortgage data:', error);
//                 setLoading(false); // Stop loading even on error
//             });
//     }, []); // Empty dependency array ensures this runs only on mount
//
//     // Loading message while fetching data
//     if (loading) {
//         return <div>Loading mortgages...</div>;
//     }
//
//     const handleRemove = async (id) => {
//         try {
//             await axios.delete(`/debt/mortgages/${id}/`); // Call DELETE API
//             // Update state to remove the deleted mortgage
//             setMortgages((prevMortgages) => prevMortgages.filter(mortgage => mortgage.id !== id));
//             alert("Loan removed successfully");
//         } catch (error) {
//             console.error("Error removing loan:", error);
//             alert("There was an error removing the loan.");
//         }
//     };
//
//     return (
//         <div>
//             <h1>Mortgage List</h1>
//             <Link to="http://localhost:3000/debt/create-loan/">
//                 <button>Create New Mortgage</button>
//             </Link>
//             <table>
//                 <thead>
//                     <tr>
//                         <th>Loan ID</th>
//                         <th>Lender</th>
//                         <th>Loan Amount</th>
//                         <th>Interest Rate</th>
//                         <th>Term (Years)</th>
//                         <th>Actions</th>
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {mortgages.map(mortgage => (
//                         <tr key={mortgage.id}>
//                             <td>
//                                 <Link to={`/financing/mortgages/${mortgage.id}`}>{mortgage.id}</Link>
//                             </td>
//                             <td>{mortgage.lender}</td>
//                             <td>{mortgage.amount}</td>
//                             <td>{mortgage.initial_interest_rate}</td>
//                             <td>{mortgage.term_in_years}</td>
//                             <td>
//                                 <button onClick={() => handleRemove(mortgage.id)}>Remove</button>
//                             </td>
//                         </tr>
//                     ))}
//                 </tbody>
//             </table>
//         </div>
//     );
// };
//
// export default MortgageList;